var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',[_c('q-card-section',{staticClass:"upload-card"},[_c('div',{staticClass:"text-subtitle1"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }